import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

export const OrderSummary = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/order-summary-revamp/components/OrderSummaryContent'
      )
  ),
  Header: lazy(
    () =>
      import(
        'components/direct-sales/order-summary-revamp/components/OrderSummaryHeader'
      )
  )
};

export default OrderSummary;
